<router-outlet></router-outlet>
<soh-material-icon-provider></soh-material-icon-provider>